import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabOutcome from '../../form-fields/tab-outcome/tab-outcome';
class EditViewPostDischargeTabOutcome extends Component {
  render() {
    return (
      <div>
         <FormFieldsTabOutcome {...this.props} locked={true} />
      </div>
    );
  }
}
EditViewPostDischargeTabOutcome.propTypes = {
  locked: PropTypes.bool,
}
EditViewPostDischargeTabOutcome = reduxForm({
  form: 'PostDischargeEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewPostDischargeTabOutcome);
export default EditViewPostDischargeTabOutcome;